// ═══════════════════════════════════════════════════════════════════════════
// i18n setup — Bombai Fase 2f (infra base, no migración masiva todavía)
// ═══════════════════════════════════════════════════════════════════════════
// Cuatro idiomas iniciales: es (default, completo), pt, en, it (skeletons —
// solo cubren los strings core/marketing; el resto se traduce gradualmente).
//
// La estrategia es:
//   1. Setup técnico ya: i18next + react-i18next + language detector
//   2. Marcar para traducción los strings de UI nuevos hechos en Fase 2c/2d/2e
//      progresivamente (sin big-bang)
//   3. Cuando se agreguen idiomas reales (Fase 8 expansión LATAM/EU), las
//      traducciones se completan con un proceso de localización dedicado.
//
// Persistencia: el idioma elegido por el usuario queda en localStorage
// (`bombai.lang`). Default: detección por navegador, fallback a español.
// ═══════════════════════════════════════════════════════════════════════════

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import esCommon from './locales/es/common.json'
import ptCommon from './locales/pt/common.json'
import enCommon from './locales/en/common.json'
import itCommon from './locales/it/common.json'

const resources = {
  es: { common: esCommon },
  pt: { common: ptCommon },
  en: { common: enCommon },
  it: { common: itCommon },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    supportedLngs: ['es', 'pt', 'en', 'it'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React ya escapa
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'bombai.lang',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false, // evita Suspense para que la app cargue inmediato
    },
  })

export default i18n

// Lista canónica de idiomas soportados — usada por el LanguageSwitcher.
export const SUPPORTED_LANGUAGES = [
  { code: 'es', label: 'Español',  flag: '🇦🇷' },
  { code: 'pt', label: 'Português', flag: '🇧🇷' },
  { code: 'en', label: 'English',  flag: '🇺🇸' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
]
